'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ShowIcon = function (props) { return (React__default['default'].createElement("svg", tslib_es6.__assign({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "currentColor" }, props),
    React__default['default'].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 23.5619L21.0711 30.633L34 17.7065L33.2925 17L21.0711 29.2186L14.711 22.8568L14 23.5619Z" }))); };

exports.default = ShowIcon;
//# sourceMappingURL=index.js.map
